import axios from "../Config/index";

const ServiceCTIRoute = {
  CreateCtiCredential: (data, type) =>
    axios.post("/service-cti/cti/credentials/" + type, data),
  GetAllCtiCredential: (param, type) =>
    axios.get("/service-cti/cti/credentials/" + type, {
      params: param,
    }),
  UpdateCtiCredential: (data, type, ctiId) =>
    axios.put("/service-cti/cti/credentials/" + type + "/" + ctiId, data),
  DeleteCtiCredential: (type, ctiId) =>
    axios.delete("/service-cti/cti/credentials/" + type + "/" + ctiId),
  GetTicketField: (type, param) =>
    axios.get("/service-cti/cti/ticket-field/" + type, {
      params: param,
    }),
  CreateCtiTicket: (type, data) =>
    axios.post("/service-cti/cti/ticket/" + type, data),
  SaveTicketField: (type, data) =>
    axios.post("/service-cti/cti/ticket-form/" + type, data),
  GetCtiLog: (param) => axios.get("/service-cti/cti/log/", { params: param }),
};
export default ServiceCTIRoute;
